/* Gorilla Karts homepage — behaviour ported from the headless Homepage.tsx (2026-08-22).
   Progressive enhancement only: the page is complete without this file.
   Loaded by every gk-home-* section; the guard below makes it run once. */
(function () {
  if (window.__gkHome) return;
  window.__gkHome = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    /* 1. Scroll-reveal (adds .gk-js so there is no flash of hidden content without JS) */
    if (!reduce) {
      document.documentElement.classList.add('gk-js');
      var targets = [];
      document.querySelectorAll('.gk-section-head').forEach(function (el) {
        el.classList.add('gk-reveal');
        targets.push(el);
      });
      ['.gk-rider-grid', '.gk-trend-grid', '.gk-carousel', '.gk-why-rail', '.gk-split-grid'].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (grid) {
          Array.prototype.forEach.call(grid.children, function (child, i) {
            child.classList.add('gk-reveal');
            child.style.transitionDelay = Math.min(i * 0.08, 0.4) + 's';
            targets.push(child);
          });
        });
      });
      document.querySelectorAll('.gk-fan').forEach(function (el) { targets.push(el); });
      if (!('IntersectionObserver' in window)) {
        targets.forEach(function (t) { t.classList.add('gk-in'); });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('gk-in'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        targets.forEach(function (t) { io.observe(t); });
      }
    }

    /* 2. Hero rotating tagline — re-mounts the span so the CSS keyframe restarts */
    document.querySelectorAll('[data-gk-rotate]').forEach(function (span) {
      if (reduce) return;
      var words;
      try { words = JSON.parse(span.getAttribute('data-gk-rotate')); } catch (e) { return; }
      if (!words || words.length < 2) return;
      var i = 0, cur = span;
      setInterval(function () {
        i = (i + 1) % words.length;
        var next = cur.cloneNode(false);
        next.textContent = words[i];
        cur.parentNode.replaceChild(next, cur);
        cur = next;
      }, 2200);
    });

    /* 3. "Why parents choose" rail — gentle auto-advance on phones, pauses when touched */
    document.querySelectorAll('.gk-why-rail').forEach(function (rail) {
      if (reduce) return;
      var isCarousel = window.matchMedia('(max-width: 860px)');
      var pausedUntil = 0;
      var pause = function () { pausedUntil = Date.now() + 7000; };
      setInterval(function () {
        if (!isCarousel.matches || Date.now() < pausedUntil) return;
        var first = rail.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 14 : rail.clientWidth;
        var max = rail.scrollWidth - rail.clientWidth;
        var next = rail.scrollLeft >= max - 4 ? 0 : rail.scrollLeft + step;
        rail.scrollTo({ left: next, behavior: 'smooth' });
      }, 3600);
      rail.addEventListener('pointerdown', pause);
      rail.addEventListener('touchstart', pause, { passive: true });
      rail.addEventListener('wheel', pause, { passive: true });
    });

    /* 4. "Rides that grow with them" age slider — pool is rendered by Liquid as JSON */
    document.querySelectorAll('[data-gk-ageslider]').forEach(function (root) {
      var meta, pool = [];
      try { meta = JSON.parse(root.getAttribute('data-gk-ageslider')); } catch (e) { return; }
      var dataEl = root.querySelector('[data-gk-agepool]');
      try { pool = JSON.parse('[' + dataEl.textContent.trim().replace(/,\s*$/, '') + ']'); } catch (e) { pool = []; }
      var range = root.querySelector('.gk-ageslider-range');
      var fig = root.querySelector('.gk-ageslider-figbox img');
      var rb = root.querySelector('.gk-ageslider-readout b');
      var rs = root.querySelector('.gk-ageslider-readout small');
      var row = root.querySelector('.gk-ageslider-row');
      var empty = root.querySelector('.gk-ageslider-empty');
      var shopAll = root.querySelector('[data-gk-shopall]');
      if (!range || !row) return;
      function band(a) { return a <= 5 ? '3-5' : a <= 8 ? '6-8' : a <= 12 ? '9-12' : a <= 15 ? 'teen' : 'adult'; }
      function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }
      function render() {
        var age = Number(range.value), b = band(age), m = meta[b];
        var figH = Math.round(48 + (Math.min(age, 16) - 3) * 4.3);
        if (fig) { fig.src = m.fig; fig.style.height = figH + 'px'; }
        if (rb) rb.textContent = age >= 16 ? 'Adult' : 'Age ' + age;
        if (rs) rs.textContent = age >= 16 ? '16 and up' : m.name;
        range.setAttribute('aria-valuetext', age >= 16 ? 'Adult' : 'Age ' + age);
        var fits = pool
          .filter(function (p) { return p.bands.indexOf(b) >= 0; })
          .sort(function (x, y) { return (Number(y.avail) - Number(x.avail)) || (x.price - y.price); })
          .slice(0, 6);
        if (fits.length) {
          row.innerHTML = fits.map(function (p) {
            return '<a class="gk-agek-card" href="' + esc(p.url) + '">' +
              '<span class="gk-agek-media"><img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy"></span>' +
              '<b>' + esc(p.name) + '</b>' +
              '<span class="gk-agek-foot"><em>£' + Math.round(p.price) + '</em>' +
              (p.avail ? '<span class="gk-plp-in">In stock</span>' : '<span class="gk-plp-out">Back soon</span>') +
              '</span></a>';
          }).join('');
          row.style.display = '';
          if (empty) empty.style.display = 'none';
        } else {
          row.innerHTML = '';
          row.style.display = 'none';
          if (empty) empty.style.display = '';
        }
        if (shopAll) {
          shopAll.href = m.href;
          var label = shopAll.querySelector('span');
          if (label) label.textContent = 'Shop everything for ' + (age >= 16 ? 'adults' : m.name);
        }
      }
      range.addEventListener('input', render);
      render();
    });
  });
})();
